export const isCourtesyHoldExpired = <T extends { days: number }>(cruiseExpiration: T) => cruiseExpiration.days === 0
